<template>
  <PageTemplate
   page-name="register"
   :is-loading="false"
  >
    <AccountTypeForm v-if="getCurrentStep === 'account-type'" />
    <PersonalDataForm v-if="getCurrentStep === 'personal-data'" />
    <OrganizationDataForm v-if="getCurrentStep === 'organization-data'" />
    <PersonalCredentialDataForm v-if="getCurrentStep === 'personal-credential-data'" />
    <OrganizationCredentialDataForm v-if="getCurrentStep === 'organization-credential-data'" />
    <SentConfirmationLetterForm v-if="getCurrentStep === 'confirmation-letter'" />
  </PageTemplate>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AccountTypeForm from '../account-type-form';
import OrganizationCredentialDataForm from '../organization-credential-data-form';
import OrganizationDataForm from '../organization-data-form';
import PersonalCredentialDataForm from '../personal-credential-data-from';
import PersonalDataForm from '../personal-data-form';
import SentConfirmationLetterForm from '../sent-confirmation-letter-form';
import { PageTemplate } from '@/shared/ui/account';

export default {
  created() {
    this.fetchActivityTypeList();
  },
  components: {
    PageTemplate, AccountTypeForm, PersonalDataForm, OrganizationDataForm, PersonalCredentialDataForm,
    OrganizationCredentialDataForm, SentConfirmationLetterForm
  },
  computed: {
    ...mapGetters('registerModule', ['getCurrentStep']),
  },
  methods: {
    ...mapActions('activityTypeModule', ['fetchActivityTypeList']),
  },
};
</script>
